import React from 'react';
import { Routes, Route} from 'react-router-dom'
import ProtectedRoute from "./ProtectedRoute";
import MembershipPlan from "../views/investor/MembershipPlan";
import AdditionalInformation from "../views/investor/additionalInformation";
import MemberShipPayment from "../views/investor/MemberShipPayment";
import MembershipPlanPaymentUSA from "../views/investor/MembershipPlanPaymenUSA";
import MainComponent from "../views/investor/main";
import InvestorProfile from "../views/investor/Profile";
import NDAComponent from "../views/common/nda-information";
import ProjectShowInterest from "../views/investor/project-show-inertest";
import Chats from "../views/common/chat";
import ListServiceView from "../views/artist/list-service";
import NotFound from "../views/common/not-found";
import NotificationCenter from "../views/common/notification-center";
import ProfileSettings from '../views/common/profileSettings';
import PasswordSettings from '../views/common/ChangePassword';
import ListServiceDetailsView from "../views/artist/list-service-details";

const ArtistRoutes = () => {
  return(
    <Routes>
      <Route  path='artists' element={<ProtectedRoute/>}>
        <Route path={'dashboard'} element={<MainComponent/>}/>
        <Route path={'projects'} element={<MainComponent/>}/>
        <Route  path={'profile'}  element={<InvestorProfile/>}/>
        <Route  path={'settings'} element={<ProfileSettings/>}/>
        <Route  path={'membership-plan'}  element={<MembershipPlan/>}/>
        <Route  path={'additional-details'}  element={<AdditionalInformation/>}/>
        <Route path={'membership-payment'} element={<MemberShipPayment/>}/>
        <Route path={'membership-plan-payment'} element={<MembershipPlanPaymentUSA/>}/>
        <Route path={'nda-information-project/:projectId'} element={<NDAComponent/>}/>
        <Route path={'project-show-interest/:projectId'} element={<ProjectShowInterest/>}/>
        <Route path={'post-list-service'} element={<ListServiceView/>}/>
        <Route path={'list-service-details/:serviceId'} element={<ListServiceDetailsView/>}/>
        <Route path={'chat'} element={<Chats/>}/>
        <Route path={'notification-center'} element={<NotificationCenter/>}/>
        <Route path={'password-settings'} element={<PasswordSettings/>}/>

      </Route>
      {/*<Route path="*" element={<NotFound />} />*/}
    </Routes>
  )
}


export default ArtistRoutes;